module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "creator-search-view"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "creator-search-view__content",
    attrs: {
      "cols": "12"
    }
  }, [_c('search-creators-data-table')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a04a259e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/SearchCreators/index.vue
// module id = 2255
// module chunks = 0